<template>
	<div class="planSection">
		<div class="dailySchedule_section">
			<h4>THE CUBS ARE OFFERING TWO SEASON TICKET PACKAGES FOR NEW SEASON TICKET HOLDERS</h4>
			<!-- <a href="#"> Dowanload Daily Schedule</a> -->
			<!-- <a v-if="purl.package_type == '2023 Daily Plan'" href="https://cubs.fanportal-mlb.com/2023/files/STH%20Renewal_Schedule_Daily_2023.pdf" class="dailySchedule_btn">Download Daily Schedule</a>
			<a v-if="purl.package_type == '2023 Combination Plan'" href="https://cubs.fanportal-mlb.com/2023/files/STH%20Renewal_Schedule_Combo_2023.pdf" class="dailySchedule_btn">Download Combination Schedule</a>
			<a v-if="purl.package_type == '2023 Double Play'" href="https://cubs.fanportal-mlb.com/2023/files/STH%20Renewal_Schedule_DoublePlay_2023.pdf" class="dailySchedule_btn">Download Double Schedule</a>
			<a v-if="purl.package_type == '2023 Half Season Red'" href="https://cubs.fanportal-mlb.com/2023/files/STH%20Renewal_Schedule_Red_2023.pdf" class="dailySchedule_btn">Download Red Schedule</a>
			<a v-if="purl.package_type == '2023 Half Season Blue'" href="https://cubs.fanportal-mlb.com/2023/files/STH%20Renewal_Schedule_Blue_2023.pdf" class="dailySchedule_btn">Download Blue Schedule</a> -->
		</div>
		<div class="plan_package_section">
			<div class="packages package1">
				<div class="header">
					<h3 class="bold">full season</h3>
					<h3>daily plan package</h3>
				</div>
				<div class="content">
					<p>Daily Plan: Tickets for all 81 home games and full range of benefits and seating options.</p>
					<br/>
					<a href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal_Schedule_Daily_2023.pdf" target="_blank" class="download_btn">View 2023 Daily Plan (81 Games)</a>
				</div>
			</div>
			<div class="packages package2">
				<div class="header">
					<h3 class="bold">Half Season</h3>
					<h3>plan package</h3>
				</div>
				<div class="content">
					<p>Half-Season Plan: Tickets for 41 games with select benefits and seating options. You have the option to pick from one of the two packages noted below.</p>
					<p>Please note the 2023 Red and Blue Half-Season Plans both include Opening Day 2023. Blue Plan seat(s) may be in a different location within the same price point for that game.</p>
					<p>Availability for the Half-Season Plan is limited. For more information on the 2023 Half-Season Plans, please check out the FAQ section at the bottom of this page. </p>
					<a href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal_Schedule_Red_2023.pdf" target="_blank" class="download_btn">View 2023 Red Plan (41 Games)</a>
					<a href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal_Schedule_Blue_2023.pdf" target="_blank" class="download_btn">View 2023 Blue Plan (41 Games)</a>
				</div>
			</div>
		</div>

		<div class="benefits_section">
			<table>
				<thead>
					<th>Benefits</th>
					<th>Daily Plan</th>
					<th>Half Season</th>
				</thead>
				<tbody>
					<tr v-for="(benefit, i) in Benefits" :key="i">
						<template v-if="benefit.benefit == 'Postseason ticket access'">
							<td>{{benefit.benefit}}</td>
							<td>ALL GAMES</td>
							<td>1 GAME PER ROUND</td>
						</template>
						<template v-else>
							<td>{{benefit.benefit}}</td>
							<td><img :src="require(`@/assets/images/icons/${benefit.DailyPlan}`)"/></td>
							<td><img :src="require(`@/assets/images/icons/${benefit.halfSeason}`)"/></td>
						</template>
					</tr>
				</tbody>
			</table>


		</div>
	</div>

</template>

<script>
export default{
	name: "PlanSection",
	data() {
		return {

			Benefits: [
				{
					id: 0,
					benefit: "Access to your seats for all regular season games",
					halfSeason: "no.svg",
					DailyPlan: "yes.svg",
				},
				{
					id: 1,
					benefit: "Lowest per ticket price",
					halfSeason: "no.svg",
					DailyPlan: "yes.svg",
				},
				{
					id: 2,
					benefit: "Season ticket seating locations available throughout the ballpark",
					halfSeason: "no.svg",
					DailyPlan: "yes.svg",
				},
				{
					id: 3,
					benefit: "Ticket Exchange Program",
					halfSeason: "no.svg",
					DailyPlan: "yes.svg",
				},
				{
					id: 4,
					benefit: "Postseason ticket access",
					halfSeason: "no.svg",
					DailyPlan: "yes.svg",
				},
				{
					id: 5,
					benefit: "Dedicated Season Ticket Representative",
					halfSeason: "yes.svg",
					DailyPlan: "yes.svg",

				},
				{
					id: 6,
					benefit: "Food and Non-Alcoholic Beverage Discount",
					halfSeason: "yes.svg",
					DailyPlan: "yes.svg",

				},
				{
					id: 10,
					// benefit: "MLB Shop online Discount Upto 15%",
					benefit: "Cubs Store and MLB Shop Discounts",
					halfSeason: "yes.svg",
					DailyPlan: "yes.svg",
				},
				{
					id: 7,
					benefit: "Priority access to special events",
					halfSeason: "yes.svg",
					DailyPlan: "yes.svg",

				},
				{
					id: 8,
					benefit: "Access to ticket presales",
					halfSeason: "yes.svg",
					DailyPlan: "yes.svg",

				},
				{
					id: 9,
					benefit: "Season Ticket Holder Gift",
					halfSeason: "yes.svg",
					DailyPlan: "yes.svg",

				},

			],

		};
	},
};

</script>
<style lang="scss" scoped>
.planSection{
	.dailySchedule_btn{
		font-family: 'Verlag Light';
		font-style: normal;
		font-weight: 325;
		font-size: 20px;
		line-height: 24px;
		background: #0E3386;
		border-radius: 55px;
		border: 1px solid  #0E3386;
		padding: 8px 60px;
		color:white;
		text-decoration:none;
		transition: all 0.3s ease 0s;
		&:hover{
			background: #CC3433;
			border: 1px solid  #CC3433;
			transform: translateY(2px);
		}
		@include media-breakpoint-down(sm) {
			font-size: 16px;
			padding: 8px 30px;
		}


	}
	.plan_package_section{
		display:flex;
		justify-content: space-between;
		margin:30px 0px;
		gap:30px;
		@include media-breakpoint-down(sm) {
			flex-direction:column;
		}
		@include media-breakpoint-only(md) {
		}
		.packages{
			flex:1;
			background-color: white;
			box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
			width:100%;
			margin: 0px 10px;
			.header{
				display:flex;
				justify-content:center;
				align-items:center;
				padding: 30px 0px;
				background: #0B2255;
				margin: 0px -10px;
				gap:10px;
				box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				@include media-breakpoint-down(sm) {
					flex-direction:column;
				}
				@include media-breakpoint-only(md) {
					flex-direction:column;
				}
				@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
					flex-direction:column;
				}
				h3{
					color:white;
					font-family: 'Verlag Condensed Light';
					font-style: normal;
					font-weight: 400;
					font-size: 35px;
					line-height: 90%;
					text-align: center;
					text-transform: uppercase;
				}
				.bold{
					font-family: 'Verlag Condensed Bold';
				}
			}

			.content{
				padding: 30px;
				margin:0px 10px;

				p{
					font-family: 'Verlag Light';
					font-style: normal;
					font-weight: 325;
					font-size: 16px;
					line-height: 145%;
					color: #474747;
				}
			}
			.download_btn{
				font-family: 'Verlag Book';
				font-style: normal;
				font-weight: 325;
				font-size: 20px;
				line-height: 24px;
				text-decoration:none;
				background: #0E3386;
				border-radius: 55px;
				padding: 8px 50px;
				display: flex;
				margin-bottom:15px;
				justify-content: center;
				align-items: center;
				color:white !important;
				@include media-breakpoint-down(sm) {
					font-size: 14px;
					padding: 8px 20px;
				}
				@include media-breakpoint-only(md) {
					font-size: 13px;
					padding: 5px 20px;
				}
				@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
					font-size: 14px;
					padding: 6px 30px;
				}
			}
		}
	}

	.benefits_section{
		background-color: white;
		box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
		padding:30px;
		margin: 20px 0px;
		table{
			width: 100%;
			th{
				color: #0E3386;
				text-align:center;
				padding: 5px;
				text-transform: uppercase;
				font-family: 'Verlag';
				font-style: normal;
				font-weight: 450;
				font-size: 18px;
				line-height: 145%;
				&:first-child(){
					text-align:left;
				}
			}
			td{
				text-transform: uppercase;
				text-align:center;
				padding: 10px;
				color: #474747;
				font-family: 'Verlag Condensed Bold';
				font-style: normal;
				font-weight: 325;
				font-size: 16px;
				line-height: 145%;
				&:first-child(){
					text-align:left;
				}
			}
		}
	}

	.dailySchedule_section {
		background-color: white;
		box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
		margin-top: 50px;
		padding: 22px;
		display:flex;
		justify-content: space-between;
		align-items:center;
		margin-bottom:10px;
		@include media-breakpoint-down(sm) {
			flex-direction:column;
		}


	}
	h4{
		font-family: "Verlag Condensed Bold";
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0px;
		text-transform: uppercase;
		color: #0E3386;
		margin-bottom:0px;
	}
	h2{
		font-family: 'Verlag Condensed Bold';
		font-style: normal;
		font-weight: 400;
		font-size: 40px;
		line-height: 100%;
		text-transform: uppercase;
		color: #0E3386;
		margin-bottom: 15px;
		@include media-breakpoint-down(sm) {
			font-size: 30px;
			margin: 15px 0px;
		}
	}
	p{
		font-family: 'Verlag Light';
		font-style: normal;
		font-weight: 325;
		font-size: 16px;
		line-height: 23px;
		color: #474747;
	}
}

</style>
